export default "__VITE_ASSET__CQ16QIlm__"